import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from 'material-ui/Typography';
import Title from '../common/Title';
import Share from '../../../../Icons/Share';
import classNames from 'classnames';

const styles = () => ({
  inline: {
    display: 'inline-flex',
    alignItems: 'center',
    width: '100%',
  },
});

class CompanyFinancialStatement extends React.Component {
  render () {
    const { classes, item } = this.props;

    if (item && item.financial_statements && item.financial_statements.length > 0) {
      return (
        <React.Fragment>
          <Title title='決算報告書' />
          <ul style={{ padding: '0px 20px 25px 20px', margin: '0'}}>
            {item.financial_statements.map((e, i) => (
              <li key={i}>
                <div className={classes.inline}>
                  <Typography variant="body2">{e.title}</Typography>
                  {e.url && (
                    <div
                      className={classNames(classes.inline, 'clickable')}
                      style={{ width: 'unset' }}
                      onClick={() => window.open(e.url, '_blank')}
                      >
                    <Share width={18} height={18} color="#71737B" style={{ marginLeft: '5px' }}/>
                    </div>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </React.Fragment>
      );
    } else {
      return null;
    }
  }
}

CompanyFinancialStatement.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
}

PropTypes.defaultValue = {
}

export default withStyles(styles)(CompanyFinancialStatement);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/parts/CompanyFinancialStatement.jsx